export default {"src":"/_next/static/image/src/images/SocialMediaIcons/instagram.6ba352b8288ecb40e07539e09d6f0d7a.svg","height":24,"width":24};